
import { defineComponent, onUnmounted, PropType } from "vue";
import Modal from "./Modal.vue";
import TUIViewer from "../application/TUIViewer.vue";
import { disableBodyOverflow, enableBodyOverflow } from "../mixins";

export default defineComponent({
  name: "NotificationModal",
  components: { TUIViewer, Modal },
  props: {
    isOpen: { type: Boolean, required: true },
    notification: { type: Object as PropType<Notification>, required: true }
  },
  setup(props) {
    if (props.isOpen) disableBodyOverflow();

    onUnmounted(() => {
      enableBodyOverflow();
    });

    return {};
  }
});
